import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import printerApi from '../../APIs/printer';
import { useRoot } from '../../context/RootProvider';
import {
  Button,
  PageHeader,
  Pagination,
  Table,
  Tag,
  Typography,
} from '../../designComponents';
import { TableDataType } from '../../designComponents/Table';
import { ADD_PRINTER_ROUTE } from '../../routes/routePaths';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import { PaginationType } from '../../types';
import { humanReadableDate, requestAPI } from '../../utils';
import { MyParamsType } from '../Building';
import { PrinterContainerStyled } from './styles';

type PrintersListType = {
  printers: {
    id: string;
    createdAt?: string;
    fullName: string;
    emailAddress: string;
    status?: string;
  };
}[];

const Printer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const { auth } = useRoot();
  console.log('auth', auth?.role);

  const pagination = useSelector(
    (state: RootState) => state.printersList.pagination
  );

  const printersList: PrintersListType = useSelector(
    (state: RootState) => state.printersList.data
  );

  const paginationAdmin = useSelector(
    (state: RootState) => state.printers.pagination
  );

  const printerListAdmin = useSelector(
    (state: RootState) => state.printers.data
  );

  const handleGetPrintList = async (myParams: MyParamsType) => {
    try {
      setLoading(true);
      await requestAPI(
        printerApi.getAllClientAssociatedPrinter({
          page: myParams.page,
          limit: myParams.limit,
          search: myParams.search ? myParams.search : '',
        })
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getAllPrinterAdmin = async (myParams: MyParamsType) => {
    try {
      setLoading(true);
      await requestAPI(
        printerApi.getAllPrinter({
          page: myParams.page,
          limit: myParams.limit,
          search: myParams.search ? myParams.search : '',
        })
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFunction = useCallback(
    debounce((myParams) => {
      if (auth?.role === 'ADMIN') {
        return getAllPrinterAdmin(myParams);
      }
      return handleGetPrintList(myParams);
    }, 500),
    []
  );

  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    debouncedFunction({ ...pagination, page: 1, search: value });
  };

  useEffect(() => {
    if (auth?.role === 'ADMIN') {
      getAllPrinterAdmin(paginationAdmin);
    } else {
      handleGetPrintList(pagination);
    }
  }, [auth?.role]);
  const handlePagination = (updatedParams: PaginationType) => {
    handleGetPrintList(updatedParams);
    dispatch(Store.Actions.update('printersList.pagination', updatedParams));
  };
  const printer =
    Array.isArray(printersList) && printersList.length > 0
      ? printersList
      : null;
  const handleAddPrinter = () => navigate(ADD_PRINTER_ROUTE);
  const tableData: TableDataType = {
    headings: [
      // {
      //   key: 'createdDate',
      //   label: 'Created Date',
      // },
      {
        key: 'fullName',
        label: 'Printer Name',
      },
      {
        key: 'emailAddress',
        label: 'Email Address',
      },
      {
        key: 'status',
        label: 'Status',
      },
    ],
    body:
      auth?.role === 'ADMIN'
        ? Array.isArray(printerListAdmin)
          ? printerListAdmin?.map((printers) => {
              return {
                id: printers?.id,
                // createdDate: humanReadableDate(printers?.createdAt),
                fullName: printers?.fullName,
                emailAddress: printers?.emailAddress,
                status: <Tag type="success">Active</Tag>,
              };
            })
          : []
        : Array.isArray(printer)
          ? printer?.map((printers) => {
              return {
                id: printers?.printers.id,
                createdDate: humanReadableDate(printers.printers.createdAt),
                fullName: printers.printers.fullName,
                emailAddress: printers.printers.emailAddress,
                status: <Tag type="success">Active</Tag>,
              };
            })
          : [],
  };
  return (
    <PrinterContainerStyled>
      <PageHeader
        pageTitle={<Typography variant="title">Printer List</Typography>}
        otherActions={
          <Button variant="secondary" size="sm" onClick={handleAddPrinter}>
            Add Printer
          </Button>
        }
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
      />

      <div className="table-container">
        <Table
          tableData={tableData}
          isLoading={loading}
          maxWidthForCardView="800px"
        />
      </div>
      <Pagination
        activePage={
          auth?.role === 'ADMIN' ? paginationAdmin.page : pagination.page
        }
        handlePagination={handlePagination}
        limit={
          auth?.role === 'ADMIN' ? paginationAdmin.limit : pagination.limit
        }
        totalCount={
          auth?.role === 'ADMIN'
            ? paginationAdmin.totalData || 0
            : pagination.totalData || 0
        }
      />
    </PrinterContainerStyled>
  );
};

export default Printer;
